/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      type
      id
      mailAddress
      displayName
      lastName
      firstName
      relationship
      birthDate
      gender
      isLiveInJapan
      postalCode
      cancerType
      cancerStage
      diagnosedDate
      diagnosedReason
      hospitalName
      curativeStatus
      cancerHistory
      diagnosedCancerType
      specialty
      affiliation
      businessTitle
      licentiate
      profile
      iconImageKey
      iconUploadedIdentityId
      iconDefaultUrl
      isDeleted
      deletedReason
      deletedAt
      createAt
      updateAt
      counselledCounts
      isCounsellingUnlimitedMode
      paymentCustomerId
      paymentProductId
      paymentSubscriptionId
      paymentSubscriptionStatus
      paymentSubscriptionStartAt
      paymentSubscriptionEndAt
      paymentSubscriptionPaidAt
      consentHamaMEDResearch
      patientIdHamaMEDHospital
      usersApplicableRightsHamaMEDHospital
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      type
      id
      mailAddress
      displayName
      lastName
      firstName
      relationship
      birthDate
      gender
      isLiveInJapan
      postalCode
      cancerType
      cancerStage
      diagnosedDate
      diagnosedReason
      hospitalName
      curativeStatus
      cancerHistory
      diagnosedCancerType
      specialty
      affiliation
      businessTitle
      licentiate
      profile
      iconImageKey
      iconUploadedIdentityId
      iconDefaultUrl
      isDeleted
      deletedReason
      deletedAt
      createAt
      updateAt
      counselledCounts
      isCounsellingUnlimitedMode
      paymentCustomerId
      paymentProductId
      paymentSubscriptionId
      paymentSubscriptionStatus
      paymentSubscriptionStartAt
      paymentSubscriptionEndAt
      paymentSubscriptionPaidAt
      consentHamaMEDResearch
      patientIdHamaMEDHospital
      usersApplicableRightsHamaMEDHospital
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      type
      id
      mailAddress
      displayName
      lastName
      firstName
      relationship
      birthDate
      gender
      isLiveInJapan
      postalCode
      cancerType
      cancerStage
      diagnosedDate
      diagnosedReason
      hospitalName
      curativeStatus
      cancerHistory
      diagnosedCancerType
      specialty
      affiliation
      businessTitle
      licentiate
      profile
      iconImageKey
      iconUploadedIdentityId
      iconDefaultUrl
      isDeleted
      deletedReason
      deletedAt
      createAt
      updateAt
      counselledCounts
      isCounsellingUnlimitedMode
      paymentCustomerId
      paymentProductId
      paymentSubscriptionId
      paymentSubscriptionStatus
      paymentSubscriptionStartAt
      paymentSubscriptionEndAt
      paymentSubscriptionPaidAt
      consentHamaMEDResearch
      patientIdHamaMEDHospital
      usersApplicableRightsHamaMEDHospital
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInformation = /* GraphQL */ `
  mutation CreateInformation(
    $input: CreateInformationInput!
    $condition: ModelInformationConditionInput
  ) {
    createInformation(input: $input, condition: $condition) {
      type
      id
      notificationTargetGroup
      notificationTargetDetail
      notificationText
      notificationUrl
      notificationStartDate
      notificationEndDate
      notificationType
      addUser
      createAt
      updateAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInformation = /* GraphQL */ `
  mutation UpdateInformation(
    $input: UpdateInformationInput!
    $condition: ModelInformationConditionInput
  ) {
    updateInformation(input: $input, condition: $condition) {
      type
      id
      notificationTargetGroup
      notificationTargetDetail
      notificationText
      notificationUrl
      notificationStartDate
      notificationEndDate
      notificationType
      addUser
      createAt
      updateAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInformation = /* GraphQL */ `
  mutation DeleteInformation(
    $input: DeleteInformationInput!
    $condition: ModelInformationConditionInput
  ) {
    deleteInformation(input: $input, condition: $condition) {
      type
      id
      notificationTargetGroup
      notificationTargetDetail
      notificationText
      notificationUrl
      notificationStartDate
      notificationEndDate
      notificationType
      addUser
      createAt
      updateAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAdviserAllowLists = /* GraphQL */ `
  mutation CreateAdviserAllowLists(
    $input: CreateAdviserAllowListsInput!
    $condition: ModelAdviserAllowListsConditionInput
  ) {
    createAdviserAllowLists(input: $input, condition: $condition) {
      type
      id
      mailAddress
      memo
      addUser
      createAt
      isRegistedUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAdviserAllowLists = /* GraphQL */ `
  mutation UpdateAdviserAllowLists(
    $input: UpdateAdviserAllowListsInput!
    $condition: ModelAdviserAllowListsConditionInput
  ) {
    updateAdviserAllowLists(input: $input, condition: $condition) {
      type
      id
      mailAddress
      memo
      addUser
      createAt
      isRegistedUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAdviserAllowLists = /* GraphQL */ `
  mutation DeleteAdviserAllowLists(
    $input: DeleteAdviserAllowListsInput!
    $condition: ModelAdviserAllowListsConditionInput
  ) {
    deleteAdviserAllowLists(input: $input, condition: $condition) {
      type
      id
      mailAddress
      memo
      addUser
      createAt
      isRegistedUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInvitationAllowLists = /* GraphQL */ `
  mutation CreateInvitationAllowLists(
    $input: CreateInvitationAllowListsInput!
    $condition: ModelInvitationAllowListsConditionInput
  ) {
    createInvitationAllowLists(input: $input, condition: $condition) {
      type
      id
      mailAddress
      memo
      addUser
      createAt
      authenticatedInvitationCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInvitationAllowLists = /* GraphQL */ `
  mutation UpdateInvitationAllowLists(
    $input: UpdateInvitationAllowListsInput!
    $condition: ModelInvitationAllowListsConditionInput
  ) {
    updateInvitationAllowLists(input: $input, condition: $condition) {
      type
      id
      mailAddress
      memo
      addUser
      createAt
      authenticatedInvitationCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInvitationAllowLists = /* GraphQL */ `
  mutation DeleteInvitationAllowLists(
    $input: DeleteInvitationAllowListsInput!
    $condition: ModelInvitationAllowListsConditionInput
  ) {
    deleteInvitationAllowLists(input: $input, condition: $condition) {
      type
      id
      mailAddress
      memo
      addUser
      createAt
      authenticatedInvitationCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStaffAllowLists = /* GraphQL */ `
  mutation CreateStaffAllowLists(
    $input: CreateStaffAllowListsInput!
    $condition: ModelStaffAllowListsConditionInput
  ) {
    createStaffAllowLists(input: $input, condition: $condition) {
      type
      id
      mailAddress
      isAdmin
      memo
      addUser
      createAt
      isRegistedUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStaffAllowLists = /* GraphQL */ `
  mutation UpdateStaffAllowLists(
    $input: UpdateStaffAllowListsInput!
    $condition: ModelStaffAllowListsConditionInput
  ) {
    updateStaffAllowLists(input: $input, condition: $condition) {
      type
      id
      mailAddress
      isAdmin
      memo
      addUser
      createAt
      isRegistedUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStaffAllowLists = /* GraphQL */ `
  mutation DeleteStaffAllowLists(
    $input: DeleteStaffAllowListsInput!
    $condition: ModelStaffAllowListsConditionInput
  ) {
    deleteStaffAllowLists(input: $input, condition: $condition) {
      type
      id
      mailAddress
      isAdmin
      memo
      addUser
      createAt
      isRegistedUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCounselingTopics = /* GraphQL */ `
  mutation CreateCounselingTopics(
    $input: CreateCounselingTopicsInput!
    $condition: ModelCounselingTopicsConditionInput
  ) {
    createCounselingTopics(input: $input, condition: $condition) {
      type
      id
      counselingCategory1
      counselingCategory2
      counselingText
      imageKey1
      imageKey2
      imageKey3
      imageUploadedIdentityId1
      imageUploadedIdentityId2
      imageUploadedIdentityId3
      counselingUserid
      responseEstimatedDate
      lastResponseDate
      status
      responseStatus
      lastResponseReplierType
      lastResponseReplierUserid
      createAt
      updateAt
      relatedLinkUrl1
      relatedLinkUrl2
      relatedLinkUrl3
      relatedLinkUrl4
      relatedLinkUrl5
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCounselingTopics = /* GraphQL */ `
  mutation UpdateCounselingTopics(
    $input: UpdateCounselingTopicsInput!
    $condition: ModelCounselingTopicsConditionInput
  ) {
    updateCounselingTopics(input: $input, condition: $condition) {
      type
      id
      counselingCategory1
      counselingCategory2
      counselingText
      imageKey1
      imageKey2
      imageKey3
      imageUploadedIdentityId1
      imageUploadedIdentityId2
      imageUploadedIdentityId3
      counselingUserid
      responseEstimatedDate
      lastResponseDate
      status
      responseStatus
      lastResponseReplierType
      lastResponseReplierUserid
      createAt
      updateAt
      relatedLinkUrl1
      relatedLinkUrl2
      relatedLinkUrl3
      relatedLinkUrl4
      relatedLinkUrl5
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCounselingTopics = /* GraphQL */ `
  mutation DeleteCounselingTopics(
    $input: DeleteCounselingTopicsInput!
    $condition: ModelCounselingTopicsConditionInput
  ) {
    deleteCounselingTopics(input: $input, condition: $condition) {
      type
      id
      counselingCategory1
      counselingCategory2
      counselingText
      imageKey1
      imageKey2
      imageKey3
      imageUploadedIdentityId1
      imageUploadedIdentityId2
      imageUploadedIdentityId3
      counselingUserid
      responseEstimatedDate
      lastResponseDate
      status
      responseStatus
      lastResponseReplierType
      lastResponseReplierUserid
      createAt
      updateAt
      relatedLinkUrl1
      relatedLinkUrl2
      relatedLinkUrl3
      relatedLinkUrl4
      relatedLinkUrl5
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCounselingReplies = /* GraphQL */ `
  mutation CreateCounselingReplies(
    $input: CreateCounselingRepliesInput!
    $condition: ModelCounselingRepliesConditionInput
  ) {
    createCounselingReplies(input: $input, condition: $condition) {
      type
      id
      counselingTopicsId
      replierType
      replierUserid
      replyText
      imageKey1
      imageKey2
      imageKey3
      imageUploadedIdentityId1
      imageUploadedIdentityId2
      imageUploadedIdentityId3
      createAt
      updateAt
      relatedLinkUrl1
      relatedLinkUrl2
      relatedLinkUrl3
      relatedLinkUrl4
      relatedLinkUrl5
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCounselingReplies = /* GraphQL */ `
  mutation UpdateCounselingReplies(
    $input: UpdateCounselingRepliesInput!
    $condition: ModelCounselingRepliesConditionInput
  ) {
    updateCounselingReplies(input: $input, condition: $condition) {
      type
      id
      counselingTopicsId
      replierType
      replierUserid
      replyText
      imageKey1
      imageKey2
      imageKey3
      imageUploadedIdentityId1
      imageUploadedIdentityId2
      imageUploadedIdentityId3
      createAt
      updateAt
      relatedLinkUrl1
      relatedLinkUrl2
      relatedLinkUrl3
      relatedLinkUrl4
      relatedLinkUrl5
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCounselingReplies = /* GraphQL */ `
  mutation DeleteCounselingReplies(
    $input: DeleteCounselingRepliesInput!
    $condition: ModelCounselingRepliesConditionInput
  ) {
    deleteCounselingReplies(input: $input, condition: $condition) {
      type
      id
      counselingTopicsId
      replierType
      replierUserid
      replyText
      imageKey1
      imageKey2
      imageKey3
      imageUploadedIdentityId1
      imageUploadedIdentityId2
      imageUploadedIdentityId3
      createAt
      updateAt
      relatedLinkUrl1
      relatedLinkUrl2
      relatedLinkUrl3
      relatedLinkUrl4
      relatedLinkUrl5
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMailNotification = /* GraphQL */ `
  mutation CreateMailNotification(
    $input: CreateMailNotificationInput!
    $condition: ModelMailNotificationConditionInput
  ) {
    createMailNotification(input: $input, condition: $condition) {
      type
      id
      targetUserid
      mailAddress
      subject
      message
      addUser
      createAt
      isNeededBackupBcc
      isNeededAsanaForward
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMailNotification = /* GraphQL */ `
  mutation UpdateMailNotification(
    $input: UpdateMailNotificationInput!
    $condition: ModelMailNotificationConditionInput
  ) {
    updateMailNotification(input: $input, condition: $condition) {
      type
      id
      targetUserid
      mailAddress
      subject
      message
      addUser
      createAt
      isNeededBackupBcc
      isNeededAsanaForward
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMailNotification = /* GraphQL */ `
  mutation DeleteMailNotification(
    $input: DeleteMailNotificationInput!
    $condition: ModelMailNotificationConditionInput
  ) {
    deleteMailNotification(input: $input, condition: $condition) {
      type
      id
      targetUserid
      mailAddress
      subject
      message
      addUser
      createAt
      isNeededBackupBcc
      isNeededAsanaForward
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createErrorLog = /* GraphQL */ `
  mutation CreateErrorLog(
    $input: CreateErrorLogInput!
    $condition: ModelErrorLogConditionInput
  ) {
    createErrorLog(input: $input, condition: $condition) {
      type
      id
      page
      url
      userid
      userType
      counselingTopicsId
      errorType
      errorNumber
      errorMessage
      addUser
      createAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateErrorLog = /* GraphQL */ `
  mutation UpdateErrorLog(
    $input: UpdateErrorLogInput!
    $condition: ModelErrorLogConditionInput
  ) {
    updateErrorLog(input: $input, condition: $condition) {
      type
      id
      page
      url
      userid
      userType
      counselingTopicsId
      errorType
      errorNumber
      errorMessage
      addUser
      createAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteErrorLog = /* GraphQL */ `
  mutation DeleteErrorLog(
    $input: DeleteErrorLogInput!
    $condition: ModelErrorLogConditionInput
  ) {
    deleteErrorLog(input: $input, condition: $condition) {
      type
      id
      page
      url
      userid
      userType
      counselingTopicsId
      errorType
      errorNumber
      errorMessage
      addUser
      createAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTimeline = /* GraphQL */ `
  mutation CreateTimeline(
    $input: CreateTimelineInput!
    $condition: ModelTimelineConditionInput
  ) {
    createTimeline(input: $input, condition: $condition) {
      type
      id
      userid
      userType
      timelineContents
      addUser
      createAt
      updateAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTimeline = /* GraphQL */ `
  mutation UpdateTimeline(
    $input: UpdateTimelineInput!
    $condition: ModelTimelineConditionInput
  ) {
    updateTimeline(input: $input, condition: $condition) {
      type
      id
      userid
      userType
      timelineContents
      addUser
      createAt
      updateAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTimeline = /* GraphQL */ `
  mutation DeleteTimeline(
    $input: DeleteTimelineInput!
    $condition: ModelTimelineConditionInput
  ) {
    deleteTimeline(input: $input, condition: $condition) {
      type
      id
      userid
      userType
      timelineContents
      addUser
      createAt
      updateAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
